import { passwordService } from "./passwordService";
import { toast } from "sonner";
import { UserRole } from "@/types/enums";

export const adminPasswordResetService = {
  /**
   * Reset a user's password as an admin
   * @param userId - The ID of the user whose password should be reset
   * @param newPassword - The new password to set
   */
  resetUserPassword: async (userId: string, newPassword: string): Promise<void> => {
    try {
      // Use the centralized password service
      const result = await passwordService.resetUserPassword(userId, newPassword);
      
      if (result.success) {
        toast.success('Password has been reset successfully!');
      } else {
        // Show the specific error message from the service
        toast.error(result.error || 'Failed to reset password');
        throw new Error(result.error || 'Failed to reset password');
      }
      
    } catch (error) {
      // Only show generic message if we haven't already shown a specific one
      const errorMessage = error instanceof Error ? error.message : String(error);
      if (!errorMessage.includes('User not found') && 
          !errorMessage.includes('Password should be') &&
          !errorMessage.includes('Password must be') &&
          !errorMessage.includes('insufficient privileges') &&
          !errorMessage.includes('Insufficient privileges') &&
          !errorMessage.includes('Company mismatch') &&
          !errorMessage.includes('outside your company') &&
          !errorMessage.includes('Invalid or expired token') &&
          !errorMessage.includes('Server configuration error') &&
          !errorMessage.includes('Unauthorized') &&
          !errorMessage.includes('Failed to reset password')) {
        toast.error('An unexpected error occurred while resetting the password.');
      }
      throw error;
    }
  },
  
  /**
   * Check if the current user has permission to reset passwords
   * @param userRole - The role of the current user
   */
  canResetPasswords: (userRole: string): boolean => {
    const adminRoles = [UserRole.SUPER_ADMIN, UserRole.APP_OWNER, UserRole.HR, UserRole.PLANT_MANAGER];
    return adminRoles.includes(userRole as UserRole);
  }
}; 